import { useMutation } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

interface IUseExportActiveUserDemographicsReportProps {
    payload: {
        filterQuery: string;
    }
}

const useExportActiveUserDemographicsReport = () => {
    const mutationFn = async (variables: IUseExportActiveUserDemographicsReportProps) => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const response = await api.get(`analytics/active-user-demographics-report/csv?${variables.payload.filterQuery}`, { responseType: 'stream' });
        return response.data;
    };

    return useMutation({
        mutationFn,
        retry: 0,
        onSuccess: async (data) => {
            const blob = new Blob([data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = 'active_user_demographics_report.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        },
        onError: () => { },
    });
};

export default useExportActiveUserDemographicsReport;